import Api from '@/api'

export default {
  state: {
    token: localStorage.getItem('rms-token') || '',
    authStatus: '',
    me: {},
    pathAfterLogin: '',
    appOptions: {}
  },
  actions: {
    async LOGIN({commit}, formData) {
      commit('AUTH_REQUEST')
      const {login, password} = formData

      try {
        const resp = await Api.login({login, password})
        const code = resp.status
        const {access_token} = resp.data
        if (code === 200 && access_token) {
          localStorage.setItem('rms-token', access_token)
          commit('AUTH_SUCCESS', access_token)
          commit('SET_HEADER_AUTH')
        } else {
          throw 'Authorization error'
        }
      } catch (err) {
        commit('AUTH_ERROR')
        localStorage.removeItem('rms-token')
      }
    },
    async LOGOUT({commit}) {
      try {
        await Api.logout()
      } finally {
        localStorage.removeItem('rms-token')
        await Api.delHeaderAuth()
        commit('AUTH_LOGOUT')
      }
    },

    async LOAD_APP_OPTIONS({commit, dispatch}) {
      try {
        const res = await Api.load_app_options()
        commit('SET_APP_OPTIONS', res.data)
      } catch (e) {
        throw `Load app options: ${e}`
      }
    },
    async GET_MY_PROFILE({commit, dispatch}) {
      try {
        const result = await Api.load_user_profile()
        commit('SET_USER', result.data)
      } catch (e) {
        dispatch('LOGOUT')
        throw `Getting profile error: ${e}`
      }
    }
  },
  mutations: {
    AUTH_REQUEST: (state) => {
      state.authStatus = 'loading'
    },
    AUTH_SUCCESS: (state, token) => {
      state.token = token
      state.authStatus = 'success'
    },
    AUTH_ERROR: (state) => {
      state.authStatus = 'error'
    },
    AUTH_LOGOUT: (state) => {
      state.authStatus = ''
      state.token = ''
    },
    SET_HEADER_AUTH: (state) => {
      Api.setHeaderAuth(state.token)
    },
    SET_REDIRECT_AFTER_LOGIN: (state, path) => {
      state.pathAfterLogin = path
    },
    SET_USER: (state, profile) => {
      state.me = {...profile}
    },
    SET_APP_OPTIONS: (state, opt) => (state.appOptions = {...opt})
  },
  getters: {
    hasToken: (state) => Boolean(state.token),
    profileLoaded: (state) => Object.keys(state.me).length > 0,
    appOptionsLoaded: (state) => Object.keys(state.appOptions).length > 0
  }
}
